// extracted by css-extract-rspack-plugin
export default {"selfAssignButton":"AssigneesSection-module__selfAssignButton__D3sTs"};